import React from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useFeatures } from '@cordata/buffet';

const DataFieldMatch = ({
  matchData,
}) => {
  const { columnLabel } = matchData;

  const startOfColumnValue = matchData.columnValue
    .slice(0, matchData.matchIndex);

  const matchingPart = matchData.columnValue
    .slice(matchData.matchIndex, matchData.matchIndex + matchData.matchLength);

  const endOfColumnValue = matchData.columnValue
    .slice(matchData.matchIndex + matchData.matchLength);

  return (
    <div style={{ fontSize: '0.8rem' }}>
      <span className="text-muted">{columnLabel}:{' '}</span>

      {startOfColumnValue}<span className="font-weight-bold">{matchingPart}</span>{endOfColumnValue}
    </div>
  );
};

DataFieldMatch.propTypes = {
  matchData: PropTypes.shape().isRequired,
};

const PatientQuickSearchResult = ({
  data,
  onClick,
}) => {
  const { hasAppIdentity } = useFeatures();

  if (hasAppIdentity) {
    return (
      <ListGroupItem
        action
        className="d-flex justify-content-between align-items-center w-100"
        style={{ cursor: 'pointer' }}
        onClick={onClick}
      >
        <span>
          {data.result.attributes.lastName}{data.result.attributes.firstName && `, ${data.result.attributes.firstName}`}

          <div style={{ fontSize: '0.8rem' }} className="text-muted">
            {data.result.attributes.sourceDescription}
          </div>

          {data.match.map(match => (
            <DataFieldMatch
              key={match.columnName}
              matchData={match}
            />
          ))}
        </span>

        <FontAwesomeIcon icon="chevron-right" className="text-muted ml-3" />
      </ListGroupItem>
    );
  }

  return (
    <ListGroupItem
      action
      className="d-flex justify-content-between align-items-center"
      style={{ cursor: 'pointer' }}
      onClick={onClick} // use onClick prop to allow division switching logic
    >
      {data.attributes.lastName}{data.attributes.firstName && `, ${data.attributes.firstName}`}

      <FontAwesomeIcon icon="chevron-right" className="text-muted" />
    </ListGroupItem>
  );
};

PatientQuickSearchResult.propTypes = {
  data: PropTypes.shape().isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PatientQuickSearchResult;
